import Base from "./base.service.js";
import Vue from "vue";
export default class Sale extends Base {
    constructor() {
        super("sale-rep");
    }
    getListSale(params) {
        return new Promise(resolve => {
            Vue.axios
                .get(this.path + "admin/", { params })
                .then(res => {
                    return resolve(res.data.data);
                })
                .catch(() => {});
        });
    }
}
